<template>
  <div class="system-pageAddD" id="app" style="overflow-y: scroll;">
    <div v-if="isLoading" class="back-loading">数据加载中...</div>
    <mt-header title="用印申请单">
      <mt-button icon="back" slot="left" @click.native="goBack">返回</mt-button>
    </mt-header>
    <div style="width: 21rem; ">
      <div class="userinfoAdd">
        <div style="border-bottom: 1px solid #e0d8d8">
          <van-field v-model="userName" label="申请人" readonly/>
        </div>
        <van-field name="uploader"
                   label="用印类型">
          <template #input>
            <div @click.prevent="useSealTypeVisible=true" style="color: black;" v-if="useSealTypeDisable">
              {{useSealType}}
              <i class="mintui mintui-field-error"></i>
            </div>
            <div  v-else style="color: black;" >
              {{useSealType}}
            </div>
          </template>
        </van-field>
        <van-field name="uploader"
                   label="印章类型">
          <template #input>
            <div @click.prevent="sealTypeVisible=true" style="color: black;">
              {{sealType}}
              <i class="mintui mintui-field-error"></i>
            </div>
          </template>
        </van-field>
        <van-field name="uploader"
                   label="固定模板"
        v-if="useSealType!='转账'">
          <template #input>
            <div @click.prevent="isfixedVisible=true" style="color: black;">
              {{isfixed}}
              <i class="mintui mintui-field-error"></i>
            </div>
          </template>
        </van-field>
        <van-field
            label="拟用印鉴"
            class="owntext"
            readonly
            v-model="proposedUseSeal"
            rows="2"
            autosize
            type="textarea"
            placeholder=""
            show-word-limit
        />
        <div class="proposedsub" @click.prevent="proposedUseSealVisible=true">选择拟用印鉴</div>
        <van-field name="uploader"
                   label="审核人员">
          <template #input>
            <div style="color: black;">{{nameuser}}</div>
          </template>
        </van-field>
        <van-field
            label="用印事由"
            class="owntext"
            v-model="processDescribe"
            rows="2"
            autosize
            type="textarea"
            placeholder="请输入用印事由"
            show-word-limit
        />
        <van-field name="uploader" label="附件">
          <template #input>
            <div  class="btn btn-default"style="position: relative; overflow: hidden;
              margin-top: 6px;">
              <i class="glyphicon glyphicon-open"></i> 上传附件
              <input type="file" name="filePath" style="opacity: 0; position: absolute;
               top: 12px; right: 0; " class='inpu' @change="fileListChange">
            </div>
          </template>
        </van-field>
        <van-field name="uploader" label="">
          <template #input>
            <div v-if="fileList.length!=0" style="display: flex; flex-direction: column;">
              <div
                  v-for="(item, idx) in fileList"
                  :key="idx"
                  style="display: flex; align-items: center; margin-bottom: 5px;">
                <span>{{ item.attachmentName }}</span><div class="delete-btn" @click.prevent="fileListdel(item)">x</div>
              </div>
            </div>
          </template>
        </van-field>
        <div style="display: flex; gap: 8px;">
          <div class="sub" @click.prevent="handelSubmit">提交</div>
          <div  class="sub" @click.prevent="caogaoSubmit">保存草稿</div>
        </div>
      </div>
    </div>
    <!-- 是否为固定模板 -->
    <mt-popup
        style="width: 100%;height: 30%"
        v-model="isfixedVisible"
        position="bottom"
        popup-transition="popup-fade"
    >
      <mt-header>
        <mt-button @click.native="isfixedVisible = false" slot="left"
        >关闭</mt-button
        >
        <mt-button @click.native="selectFixedPicker" slot="right"
        >确认</mt-button
        >
      </mt-header>
      <mt-picker
          :slots="isfixedList"
          ref="isfixedList"
          valueKey="name"
      ></mt-picker>
    </mt-popup>
    <!-- 用印类型 -->
    <mt-popup
        style="width: 100%;height: 30%"
        v-model="useSealTypeVisible"
        position="bottom"
        popup-transition="popup-fade"
    >
      <mt-header>
        <mt-button @click.native="useSealTypeVisible = false" slot="left"
        >关闭</mt-button
        >
        <mt-button @click.native="selectUseSealTypePicker" slot="right"
        >确认</mt-button
        >
      </mt-header>
      <mt-picker
          :slots="useSealTypeList"
          ref="useSealTypeList"
          valueKey="name"
      ></mt-picker>
    </mt-popup>
    <!-- 印章类型 -->
    <mt-popup
        style="width: 100%;height: 30%"
        v-model="sealTypeVisible"
        position="bottom"
        popup-transition="popup-fade"
    >
      <mt-header>
        <mt-button @click.native="sealTypeVisible = false" slot="left"
        >关闭</mt-button
        >
        <mt-button @click.native="selectSealTypePicker" slot="right"
        >确认</mt-button
        >
      </mt-header>
      <mt-picker
          :slots="sealTypeList"
          ref="sealTypeList"
          valueKey="name"
      ></mt-picker>
    </mt-popup>
    <!-- 选择拟用印鉴 -->
    <mt-popup
        style="width: 100%;height: 90%"
        v-model="proposedUseSealVisible"
        position="bottom"
        popup-transition="popup-fade"
    >
      <mt-header title="选择拟用印鉴">
        <mt-button @click.native="proposedUseSealVisible = false" slot="left"
        >关闭</mt-button
        >
        <mt-button @click.native="selectProposedUseSealPicker" slot="right"
        >确认</mt-button
        >
      </mt-header>
      <mt-field
          v-model="searchQuery"
          placeholder="搜索"
          clearable
          @clear="clearSearch"
          style="margin: 10px;"
      />
      <div class="custom-list">
        <div class="header" style="display: flex; align-items: center; padding: 10px 0; background-color: #f5f5f5;position: sticky; top: 0">
          <div class="title" style="flex-grow: 1;font-weight: bold;margin-left: 150px">单位名称</div>
        </div>
        <div class="scrollable-content" style="max-height: 600px; overflow-y: auto;">
          <div
              v-for="(proposed, index) in filteredProposed"
              :key="proposed.proposedId"
              class="list-item"
          >
            <div class="item-content" style="display: flex; align-items: center;">
              <input
                  type="checkbox"
                  v-model="selectedProposed[proposed.proposedId]"
                  style="float: left;width: 1rem;"
              />
              <div class="title" style="flex-grow: 1;width: 5rem;margin-left: 10px">{{ proposed.companyName }}</div>
            </div>
          </div>
        </div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
import {Toast} from "mint-ui";
import {getLocalData} from "@/utils/sessionData";
import axios from "axios";
import request from "@/utils/keyCloakRequest";

export default {
  data() {
    return {
      fileList: [],
      fileIds: [],
      isfixed: '是',//是否为固定模板 0:是 1：否
      useSealType: '合同用印',//用印类型 合同用印 非合同用印
      sealType: '公章',//印章类型  公章 财务章 网银复核
      proposedUseSeal: '',//拟用印鉴
      processDescribe: "",
      userName: "",
      userId:"",
      isLoading: false,
      nameuser: null,//审核人姓名
      userInfo:{},
      isfixedList:[
        {
          values: [
            {
              code: "是",
              name: "是"
            },
            {
              code: "否",
              name: "否"
            }
          ],
          className: "slot1"
        }
      ],
      useSealTypeList:[
        {
          values: [
            {
              code: "合同用印",
              name: "合同用印"
            },
            {
              code: "非合同用印",
              name: "非合同用印"
            }
          ],
          className: "slot1"
        }
      ],
      sealTypeList:[
        {
          values: [
            {
              code: "公章",
              name: "公章"
            },
            {
              code: "财务章",
              name: "财务章"
            },
            {
              code: "网银复核",
              name: "网银复核"
            }
          ],
          className: "slot1"
        }
      ],
      useSealTypeDisable: true,
      proposedUseSealList:[],
      isfixedVisible: false,//是否为固定模板 0:是 1：否
      useSealTypeVisible: false,//用印类型 合同用印 非合同用印
      sealTypeVisible: false,//印章类型  公章 财务章 网银复核
      proposedUseSealVisible: false,
      selectedProposed:[],
      filteredProposed:[],
      searchQuery: '',
      roleId:'',
      route:'',
      item:{},
      processId:'',
    };
  },
  computed: {
  },
  async created() {
    this.userInfo = JSON.parse(getLocalData("userInfo"))
    this.userName = this.userInfo.userName
    this.userId = this.userInfo.userId
    this.roleId = this.userInfo.role.roleId
    if(this.userId==this.userInfo.dept.deptmanager){
      if(this.roleId==12){
        this.nameuser = '何海波'
      }else {
        request({
          url: "getFgldName?userId="+this.userId,
          method: "get"
        }).then( response => {
          this.nameuser = response
        })
      }
    }else {
      request({
        url: "getManagerName?userId="+this.userId,
        method: "get"
      }).then( response => {
        this.nameuser = response
      })
    }
    await request({
      url: "useSealTypeselect?val=公章",
      method: "get"
    }).then( response => {
      this.proposedUseSealList = response
      this.filterProposeds()
    })
    this.processId = this.$route.query.item==undefined?'':this.$route.query.item.processId
    if(this.processId){
      axios({
        url: process.env.VUE_APP_SSO_URL+"appUseSealDetail?processId="+this.processId,
        method: "get",
      }).then(response => {
        this.item = response.data
        console.log(this.item)
        this.isfixed = this.item.isfixed,//是否为固定模板 0:是 1：否
        this.useSealType = this.item.useSealType,//用印类型 合同用印 非合同用印
        this.sealType = this.item.sealType,//印章类型  公章 财务章 网银复核
        this.proposedUseSeal = this.item.proposedUseSeal//拟用印鉴
        if(this.sealType=="财务章"||this.sealType=="网银复核"){
          this.useSealTypeDisable = false
          if (this.roleId==12){
            this.nameuser = '孙良康'
          }
        }else {
          this.useSealTypeDisable = true
        }
        const selectedCompanies = this.proposedUseSeal.split(',').map(name => name.trim());
        this.proposedUseSealList.forEach(item => {
          this.selectedProposed[item.proposedId] = selectedCompanies.includes(item.companyName);
        });
        this.processDescribe = this.item.processDescribe	//流程用印事由
        if(this.item.proFileid!=""){
          this.fileIds =   this.item.proFileid.split(",")
          request({
            url: "appDocumentFile?fileIds="+this.item.proFileid,
            method: "get"
          }).then(  response => {
            response.forEach(file => {
              this.fileList.push(file)
            });
          })
        }
      })
    }
    this.route =  this.$route.query.route
  },
  watch: {
    searchQuery(val) {
      this.filterProposeds(val);
    },
  },
  methods: {
    filterProposeds(query) {
      if (!query) {
        this.filteredProposed = [...this.proposedUseSealList];
      } else {
        this.filteredProposed = this.proposedUseSealList.filter(proposed =>
            proposed.companyName.toLowerCase().includes(query.toLowerCase())
        );
      }
    },
    selectProposedUseSealPicker(){
      if(this.selectedProposed!=null) {
        const selectedIds = Object.keys(this.selectedProposed)
            .filter(key => this.selectedProposed[key] === true)
            .map(Number);
        const selectedCompanyNames = this.proposedUseSealList
            .filter(proposed => selectedIds.includes(proposed.proposedId))
            .map(proposed => proposed.companyName);
        this.proposedUseSeal =  selectedCompanyNames.join(', ');
      }
      this.proposedUseSealVisible = false
    },
    clearSearch() {
      this.searchQuery = '';
      this.filteredProposed = [...this.proposedUseSealList];
    },
    selectFixedPicker(){
      this.isfixed = this.$refs.isfixedList.getValues()[0].code;
      this.isfixedVisible = false
    },
    selectUseSealTypePicker(){
      this.useSealType = this.$refs.useSealTypeList.getValues()[0].code;
      this.useSealTypeVisible = false
      if (this.roleId==12){
        if(this.useSealType=='合同用印'){
            this.nameuser = '何海波'
        }else {
            this.nameuser = '孙良康'
        }
      }
    },
   async selectSealTypePicker(){
      this.sealType = this.$refs.sealTypeList.getValues()[0].code;
      if(this.sealType=="财务章"||this.sealType=="网银复核"){
        this.useSealType = "转账"
        this.useSealTypeDisable = false
        if (this.roleId==12){
            this.nameuser = '孙良康'
        }
      }else {
        this.useSealTypeDisable = true
        this.useSealType = "合同用印"
      }
      await request({
        url: "useSealTypeselect?val="+this.sealType,
        method: "get"
      }).then( response => {
        this.proposedUseSealList = response
      })
      this.sealTypeVisible = false
    },
    formatDate(timestamp) {
      // 创建一个新的Date对象，使用时间戳初始化
      const date = new Date(timestamp);

      // 获取各个时间组件
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份从0开始，需要加1
      const day = date.getDate().toString().padStart(2, '0');
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');

      // 组合成所需的格式
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    fileListChange(event){
      const file = event.target.files[0]
      axios({
        url: process.env.VUE_APP_SSO_URL+"appSavePfile",
        method: "POST",
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: {file:file,userId:this.userId}
      }).then(  response => {
        this.fileList.push(response.data)
        this.fileIds.push(response.data.attachmentId)
      })
    },
    fileListdel(attachment){
      this.fileList.splice(this.fileList.indexOf(attachment),1)
      this.fileIds.splice(this.fileIds.indexOf(attachment.attachmentId),1)
    },
    caogaoSubmit() {
      if (!this.processDescribe) {
        Toast({
          message: "请填写用印事由"
        });
        return;
      }
      if (!this.proposedUseSeal) {
        Toast({
          message: "请填写拟用印鉴"
        });
        return;
      }
      let params = {
        processId : this.processId,
        nameuser : this.nameuser,
        processDescribe : this.processDescribe,	//流程用印事由
        userId : this.userId,			//流程申请人
        isfixed: this.isfixed,//是否为固定模板 0:是 1：否
        useSealType: this.useSealType,//用印类型 合同用印 非合同用印
        sealType: this.sealType,//印章类型  公章 财务章 网银复核
        proposedUseSeal: this.proposedUseSeal,//拟用印鉴
        proFileid:this.fileIds.join(','),
        statusId:22
      };
      axios({
        url: process.env.VUE_APP_SSO_URL+"appUseSeal",
        method: "POST",
        data:params
      }).then(res => {
        console.log(res)
        if(res.data=='sucess'){
          Toast({
            message: "新增成功",
            position: 'middle',
            iconClass: "icon icon-success"
          });
          this.goBack();
        }
        else {
          Toast({
            message: res.data,
            position: 'middle',
            iconClass: "icon icon-success"
          });
        }
      })
    },
    handelSubmit() {
      if (!this.processDescribe) {
        Toast({
          message: "请填写用印事由"
        });
        return;
      }
      if (!this.proposedUseSeal) {
        Toast({
          message: "请填写拟用印鉴"
        });
        return;
      }
      let params = {
        processId : this.processId,
        nameuser : this.nameuser,
        processDescribe : this.processDescribe,	//流程用印事由
        userId : this.userId,			//流程申请人
        isfixed: this.isfixed,//是否为固定模板 0:是 1：否
        useSealType: this.useSealType,//用印类型 合同用印 非合同用印
        sealType: this.sealType,//印章类型  公章 财务章 网银复核
        proposedUseSeal: this.proposedUseSeal,//拟用印鉴
        proFileid:this.fileIds.join(','),
        statusId:23
      };
      axios({
        url: process.env.VUE_APP_SSO_URL+"appUseSeal",
        method: "POST",
        data:params
      }).then(res => {
        console.log(res)
        if(res.data=='sucess'){
          Toast({
            message: "新增成功",
            position: 'middle',
            iconClass: "icon icon-success"
          });
          this.goBack();
        }
        else {
          Toast({
            message: res.data,
            position: 'middle',
            iconClass: "icon icon-success"
          });
        }
      })
    },
    goBack() {
      this.$router.push(this.route==undefined?"/procedure/addProcedure":this.route);
    }
  },
};
</script>

<style lang="less">
@color: #ffffff;
@border-rd: 10px;

html {
  overflow: hidden;
  height: 100%;
  background: #f5f5f5;
}

body {
  display: block;
  margin: 0rem !important;
}
.app {
  /* padding: 0.5rem; */
  background-color: rgb(240, 240, 240, 0.75);
}
.van-field__control {
  line-height:  2rem;
  font-size: 1.5rem !important;
  margin-top: 10px;
}
.van-field__label {
  span{
    font-size: 1.2rem !important;
    font-weight: 700;
    color: #6d9eeb
  }
  width: 8.2rem;
  line-height:  2rem;
  font-size: 2rem !important;
  margin-top: 10px;
}
.van-field__value {
  line-height:  2rem;
  font-size: 2rem !important;
  margin-top: 10px;
}
.delete-btn {
  color: red;
  cursor: pointer;
  margin-left: 50px;
}
.userinfoAdd {
  .idea {
    height: 2.466667rem;
    line-height: 2.466667rem;
    font-size: 1rem;
    background: #efefef;
    color: #646566;
    text-align: center;
    margin-bottom: 0.4rem;
    margin: 0.5rem 0;
  }
  .mint-cell-label {
    font-size: 1.2rem !important;
    font-weight: 700;
    color: #6d9eeb !important;
    margin-left: -20px;
  }
  .owntext {
    padding: 0 !important;

    .van-field__control {
      height: 600px !important;
    }
    .van-field__word-limit {
      height: 75px;
      line-height: 75px;
      margin-bottom: 30px;
    }
  }
  .ownupload {
    margin: 0.5rem 0;
    .van-uploader__preview {
      margin: 10px 10px 10px 0;
      .van-image__error-icon {
        font-size: 90px;
      }
    }
    .van-uploader__preview-image,
    .van-uploader__upload {
      width: 200px;
      height: 200px;
      border: 1px dashed #ccc;
      .van-uploader__upload-icon {
        font-size: 90px;
      }
    }
    .van-uploader__preview-delete {
      width: 50px;
      height: 50px;
      .van-uploader__preview-delete-icon {
        font-size: 55px;
      }
    }
  }
  .van-cell {
    align-items: center;
    .van-field__label {
      width: 400px;
      font-size: 60px;
      height: 100px;
      line-height: 100px;
      color: #382c2c;
    }
  }
  .van-field__body {
    input {
      border: none !important;
      color: black;
    }
    textarea {
      padding-left: 30px;
    }
  }
  .proposedsub {
    width: 100%;
    height: 200px;
    line-height: 200px;
    font-size: 75px;
    background: #5f9cf5;
    border-radius: 50px 50px 50px 50px;
    text-align: center;
    cursor: pointer;
    color: #e5f4f9;
    margin-top: 100px;
  }
  .sub {
    width: 50%;
    height: 200px;
    line-height: 200px;
    font-size: 75px;
    background: #5f9cf5;
    border-radius: 50px 50px 50px 50px;
    text-align: center;
    cursor: pointer;
    color: #e5f4f9;
    margin-top: 100px;
  }
}
.system-pageAddD {
  width: 100%;
  height: 100vh;
  background-color: #fff;
  font-family: "PingFangSC-Regular";
}

/** 加载中 */
.back-loading {
  width: 100%;
  height: 100%;
  background-color: white;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  text-align: center;
  line-height: 25rem;
  font-size: 1rem;
  color: grey;
}
.van-field__error-message {
  line-height: 1.3rem;
}
.custom-list {
  overflow-y: auto; /* 如果内容超出容器高度，则启用垂直滚动 */
  padding: 0;
  margin: 0;
  list-style: none; /* 移除默认的列表样式 */
  background-color: #fff; /* 背景颜色 */
  border-radius: 4px; /* 圆角 */
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1); /* 阴影效果 */
}
.list-item {
  line-height: 1.4rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  border-bottom: 1px solid #ebeef5; /* 分隔线 */
}
.list-item input:disabled {
  opacity: 0.5; /* 置灰效果 */
  cursor: not-allowed; /* 禁止点击的鼠标样式 */
}
.item-content{
  width: 21rem;
}
/* 为title定义样式，这通常是列表项中的主标题 */
.title {
  font-size: 1.213333rem; /* 字体大小 */
  font-weight: bold; /* 加粗 */
  color: #333; /* 字体颜色 */
  margin-bottom: 8px; /* 与副标题之间的间距 */
}

/* 为subtitle定义样式，这通常是列表项中的副标题或额外信息 */
.subtitle {
  font-size: 1.213333rem; /* 字体大小 */
  color: #666; /* 字体颜色 */
}

/* 额外的样式，例如复选框 */
.list-item input[type="checkbox"] {
  margin-top: 0; /* 移除复选框上方的默认间距 */
  margin-right: 16px; /* 复选框与文本之间的间距 */
}
.van-picker__toolbar {
  height: 1.586667rem;
}
.van-picker__cancel, .van-picker__confirm {
  padding: 0 0.213333rem;
  font-size: 1.186667rem;
}
.van-picker__title {
  font-size: 1.213333rem;
  line-height: 1.266667rem;
}
.van-picker-column__item {
  line-height: 1rem
}
.van-picker-column {
  font-size: .8rem;
}
.van-cell {
  font-size: 0.9rem;
  line-height: 1.32rem;
}
.van-field__control:read-only {
  font-size: .8rem;
}
</style>
